import { NestedError } from "abweb/dto/exception/NestedError";
import { RemoteAbInitioErrorExceptionBase } from "abweb/dto/generated/exception/RemoteAbInitioErrorExceptionBase";
export class RemoteAbInitioErrorException extends RemoteAbInitioErrorExceptionBase {
  static createRemoteAbInitioErrorException(exceptionTime, message, messageArgs, messageCode, remoteCause, remoteNestedErrors, remoteStackTrace) {
    const retVal = new RemoteAbInitioErrorException();
    retVal.initRemoteAbInitioErrorException(exceptionTime, message, messageArgs, messageCode, remoteCause, remoteNestedErrors, remoteStackTrace);
    return retVal;
  }
  static createFromMessage(message, ...messageArgs) {
    return RemoteAbInitioErrorException.createRemoteAbInitioErrorException(null, message, messageArgs, null, null, null, null);
  }

  /**
   * Removes leading slash from escaped chars, like \\, \\r, \\n, \\t.
   */
  static unescapify(str) {
    return str.replace(/\\\\/g, "\\") // replace 'double backslash' with single backslash
    .replace(/\\r\\n/g, "\n") // replace 'backslash R backslash N' with CR-LF
    .replace(/\\n/g, "\n") // replace 'backslash N' with LF
    .replace(/\\t/g, "\t"); // replace 'backslash T' with TAB
  }
  initFromJson(json, deserializeContext) {
    // ABSDK-1657: gracefully detect if it is a RemoteAbInitioErrorException payload
    // Do NOT want this to parse to an empty RemoteAbInitioErrorException as it would with this 'custom error' json:
    //      { errorMessagee: "foo", errorMessageCode: 23 }
    // Elliot points out that graphs have a 'dml' seraialization that do NOT send @class,
    // so require either message or messageCode prop to be set so that something meaningful
    // is guaranteed to be in the parsed RemoteAbInitioErrorException.
    if (!(json?.message || json?.messageCode)) {
      throw new Error("Can not deserialize json error payload as a RemoteAbInitioErrorException as it must have either a non-empty messageCode or message property.");
    }
    super.initFromJson(json, deserializeContext);
  }
  get chainedMessage() {
    return this.message + (this.remoteCause ? NestedError.causedByPrefix + this.remoteCause.chainedMessage : "");
  }
  toString() {
    // CAT-740: pretty print the remote errors, which include stack dumps that contain slashes.
    return RemoteAbInitioErrorException.unescapify(JSON.stringify(this, undefined, " "));
  }
}
//# sourceMappingURL=RemoteAbInitioErrorException.js.map
